export const createAddNewTagTemplate = () =>
  '<li data-index="0" class="add-tag">Add New Tag</li>';

export const createMenuContainer = () => '<div class="tribute-wrapper"></div>';
